//订单状态 1：创建订单2.待付款 3.待鉴定 4鉴定完成 5取消鉴定 6.暂定等待 7.已评价 默认 4
export const ORDER_STATUS_NONE      = 0;
export const ORDER_STATUS_CREATE    = 1;
export const ORDER_STATUS_TOPAY     = 2;
export const ORDER_STATUS_WAIT      = 3;
export const ORDER_STATUS_FINISHED  = 4;
export const ORDER_STATUS_CANCEL    = 5;
export const ORDER_STATUS_PAUSE     = 6;
export const ORDER_STATUS_EVALUATE  = 7;

export const ORDER_STATUS_TEXT = ['无状态','待提交','待付款','待鉴定','鉴定完成','已取消','资料待修正','已评价'];

export const SERVICE_TYPE = {
    1           : '普通鉴定',
    2           : '极速鉴定',
    default     : ''
};

export const VIDEO_DEFAULT_IMG = 'https://imgcdn-prd.pydp888.com/file/0/1/246100/20200729/aea4358c727b78fc203869f1b68ffb98.png?x-oss-process=image/resize,m_fill,w_400,h_400,limit_0/auto-orient,1/quality,q_90'

export const IS_REAL_TRUE  = 100;
export const IS_REAL_FALSE  = 200;
export const IS_REAL_NOW  = 300;